<!-- KPI card: single dataset, one column aggregated (sum / distinct / …) to
     a single headline value. -->
<div class="wf-section" *ngIf="active">
  <header class="wf-section-header">
    <h3>{{ host.layoutSectionTitle('kpi', 'KPI card') }}</h3>
  </header>
  <small class="control-hint" *ngIf="host.layoutSectionHint('kpi')">{{ host.layoutSectionHint('kpi') }}</small>
  <ng-container *ngTemplateOutlet="datasetPicker"></ng-container>

  <div class="control-row">
    <div class="control-group wf-field-drop-zone" (dragover)="host.allowFieldDrop($event)" (drop)="onKpiFieldDrop($event)" title="Drag a column here">
      <label>{{ host.fieldLabel('kpi', 'field', 'Column') }}</label>
      <ng-select
        #ssKpiField
        class="ss-select"
        [class.is-open]="!!ssKpiField.isOpen?.()"
        appendTo="body"
        ngClass="ss-dropdown-panel"
        [items]="host.drillDatasetColumns"
        [clearable]="true"
        [searchable]="true"
        [loading]="host.isDrillDatasetColumnsLoading"
        [disabled]="!host.drillDataset"
        [placeholder]="host.drillColumnPlaceholder('measure')"
        [ngModel]="kpiField || null"
        (ngModelChange)="kpiField = $event || ''"
      ></ng-select>
    </div>
    <div class="control-group">
      <label>{{ host.fieldLabel('kpi', 'aggregation', 'Aggregation') }}</label>
      <ng-select
        #ssKpiAgg
        class="ss-select"
        [class.is-open]="!!ssKpiAgg.isOpen?.()"
        appendTo="body"
        ngClass="ss-dropdown-panel"
        [items]="kpiAggregations"
        bindLabel="label"
        bindValue="value"
        [clearable]="true"
        [ngModel]="kpiAggregation"
        (ngModelChange)="kpiAggregation = $event ?? ''"
      ></ng-select>
    </div>
  </div>
  <div class="control-row" *ngIf="host.fieldEnabled('kpi', 'formula')">
    <div class="control-group control-group-full wf-field-drop-zone" (dragover)="host.allowFieldDrop($event)" (drop)="onKpiFormulaFieldDrop($event)" title="Drag a column here">
      <label>{{ host.fieldLabel('kpi', 'formula', 'Formula (optional)') }}</label>
      <input type="text" [(ngModel)]="kpiFormula" placeholder="e.g. [price] * [qty] — overrides Column + Aggregation when set" />
    </div>
  </div>

  <!-- References: when the formula's [Token] isn't a plain dataset column
       but another input's live/recomputed output, type in where it comes
       from so the backend resolves the CURRENT value instead of a stale
       one. Keyed by THIS KPI's own componentId. -->
  <ng-container *ngIf="host.fieldEnabled('kpi', 'formula') && host.formulaReferencesEnabledFor('KPI')">
    <ng-container *ngTemplateOutlet="referenceList; context: { id: host.componentId }"></ng-container>
  </ng-container>

  <!-- Format accordions (registry `sections`-gated; shell formatControls) -->
  <ng-container [ngTemplateOutlet]="chartFormatAccordion"></ng-container>
</div>
